export const guestSurvey = {
    method: 'POST',
    paths: [
        '/api/orgs/:orgId/locations/:locationId/orders/:orderId/guestSurvey',
        '/api/orgs/:orgId/locations/:locationId/orderByClientId/:clientOrderId/guestSurvey',
    ],
    fields: {
        surveyValue: {
            type: 'int',
            required: true,
            min: 0,
            max: 3,
        },
    },
};
//# sourceMappingURL=orders_guest_survey.js.map